import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import { Order } from "../../api/api-generated";
import { Item } from "../../utils/sharedTypes";
import HardwareOptionsBarForOrder from "./HardwareOptionsBarForOrder";
import HardwareTable from "./HardwareTable";
import { HardwareItemFilter } from "./hardwareTypes";

interface Props {
  dialogOpen: boolean;
  setDialogOpen: React.Dispatch<React.SetStateAction<boolean>>;
  order?: Order;
}

const initialFilters: HardwareItemFilter = {
  hardwareType: null,
  company: null,
  serial: "",
  soldDateFrom: "",
  soldDateTo: "",
  warrantyActive: "",
};

const HardwareDialog = ({ dialogOpen, setDialogOpen, order }: Props) => {
  const [selectedHardware, setSelectedHardware] = useState<Item[]>([]);
  return (
    <Dialog
      fullWidth
      maxWidth="xl"
      open={dialogOpen}
      aria-labelledby="form-dialog-title"
    >
      <DialogTitle>Manage Hardware</DialogTitle>
      <DialogContent>
        <Typography variant="subtitle2" style={{ marginBottom: "1rem" }}>
          {order && `Hardware for Order ${order.purchaseOrderName}`}
        </Typography>
        <HardwareTable
          setSelectedHardware={setSelectedHardware}
          order={order}
          filters={initialFilters}
          lptSold={true}
        />
        {order && (
          <HardwareOptionsBarForOrder
            selectedHardware={selectedHardware}
            setSelectedHardware={setSelectedHardware}
            order={order}
          />
        )}
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            setDialogOpen(false);
            setSelectedHardware([]);
          }}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default HardwareDialog;
